module.exports = __webpack_public_path__ + "media/images/result-null-state-4ab8659c2a8a3ac056e5fdc9c7fd7e4a.png";